<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Regra Fiscal</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar" v-if="getPermissionFw('regrafiscal.store')"><i class="fa fa-plus"></i></a></li>
                                    <li><a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreenFw()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreenFw()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHideFw()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros"  v-if="getPermissionFw('regrafiscal.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inutilizar Registros"  v-if="getPermissionFw('regrafiscal.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    <div class="card-content">
                        <div class="table-responsive">
                            <div v-if="vuetableFilterRow">
                                <vuetable-filterbar :tabela="'regra_fiscal'">
                                </vuetable-filterbar>
                            </div>
                        <div class="loadingDataPosition">
                            <div class="loadingData" v-if="loadingData"><div class="loadingDataSpinner"><spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                            <vuetable ref="vuetable"
                                    api-url="/api/regrafiscal"
                                    :fields="fields"
                                    :css="css"
                                    :append-params="moreParams"
                                    track-by="regfis_id"
                                    detail-row-component="regra-fiscal-detalhes"
                                    @vuetable:cell-clicked="onDetail"
                                    pagination-path=""
                                    @vuetable:load-error="onError"
                                    @vuetable:pagination-data="onPaginationData"
                                    @vuetable:loaded="onLoaded"
                                  >
                                    <template slot="status" slot-scope="props">
                                        <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                        <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                    </template>

                                    <template slot="simplesnacional" slot-scope="props">
                                        <span class="badge badge-success" v-if="props.rowData.simples_nacional != null && props.rowData.simples_nacional.valor==1">{{ props.rowData.simples_nacional.descr }}</span>
                                        <span class="badge badge-danger" v-if="props.rowData.simples_nacional != null && props.rowData.simples_nacional.valor==2">{{ props.rowData.simples_nacional.descr }}</span>
                                    </template>

                                    <template slot="cst" slot-scope="props">
                                        <span>{{ props.rowData.param_cst.cd }} - {{ props.rowData.param_cst.descr }}</span>
                                    </template>

                                  <template slot="status" slot-scope="props">
                                      <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                      <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                  </template>
                                  <template slot="actions" slot-scope="props">
                                    <div class="custom-actions">
                                        <a @click="onEdit(props.rowData)" v-b-tooltip title="Editar"  v-if="getPermissionFw('regrafiscal.update')"><i class="fa fa-edit"></i></a>
                                        <span v-if="getPermissionFw('regrafiscal.status')">
                                            <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                            <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                        </span>
                                        <a @click="onCreateUnidade(props.rowData)"  v-if="getPermissionFw('regrafiscal.unidade.store')" v-b-tooltip title="Vincular Unidade"><i class="fa fa-home"></i></a>
                                        <a @click="onCreateCliente(props.rowData)"  v-if="getPermissionFw('regrafiscal.cliente.store')" v-b-tooltip title="Vincular Cliente"><i class="fa fa-user"></i></a>
                                        <a @click="onCreateTransportador(props.rowData)"  v-if="getPermissionFw('regrafiscal.transportador.store')" v-b-tooltip title="Vincular Transportador"><i class="fa fa-truck"></i></a>
                                        <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                      </button>
                                    </div>
                                  </template>
                            </vuetable>
                        </div>
                    <div>
                        <div class='col-md-12'>
                            <div class="pull-left pagination-detail">
                                <vuetable-pagination-info ref="paginationInfo"
                                                          :css="css.pagination"
                                                          info-class="pull-left"
                                ></vuetable-pagination-info>
                            </div>
                            <div class="pull-right m-a-0">
                                <vuetable-pagination ref="pagination"
                                                     :css="css.pagination"
                                                     @vuetable-pagination:change-page="onChangePage"
                                ></vuetable-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<RegraFiscalForm
    ref="regrafiscalform" :metodo="onReloadData" :tabela="'regra_fiscal'" :rota="'regrafiscal'">
</RegraFiscalForm>
<RegraFiscalUnidadeForm
    ref="regrafiscalunidadeform" :metodo="onReloadData" :tabela="'regra_fiscal_unidade'" :rota="'regrafiscalunidade'">
</RegraFiscalUnidadeForm>
<RegraFiscalClienteForm
    ref="regrafiscalclienteform" :metodo="onReloadData" :tabela="'regra_fiscal_cliente'" :rota="'regrafiscalcliente'">
</RegraFiscalClienteForm>
<RegraFiscalTransportadorForm
    ref="regrafiscaltransportadorform" :metodo="onReloadData" :tabela="'regra_fiscal_transportador'" :rota="'regrafiscalcliente'">
</RegraFiscalTransportadorForm>
              </div>
          </div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import RegraFiscalFilterBar from './RegraFiscalFilterBar'
import RegraFiscalForm from './RegraFiscalForm'
import RegraFiscalUnidadeForm from './RegraFiscalUnidadeForm'
import RegraFiscalClienteForm from './RegraFiscalClienteForm'
import RegraFiscalTransportadorForm from './RegraFiscalTransportadorForm'
import RegraFiscalDetalhes from './RegraFiscalDetalhes'

Vue.component('regra-fiscal-detalhes', RegraFiscalDetalhes);

export default {
components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    RegraFiscalForm,
    RegraFiscalUnidadeForm,
    RegraFiscalClienteForm,
    RegraFiscalTransportadorForm,
    'vuetable-filterbar': RegraFiscalFilterBar
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({ cd: '',
                       descr: '',
                       regfis_id: '',
                       status: []
                   }),
     helpForm: new Form({statusRecord: [], status: ''}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: 'param_situacao_tributaria.descr',
        title: 'Situação tributária',
        sortField: 'param_situacao_tributaria.descr'
      },
      {
        name: 'param_tipo_imposto.descr',
        title: 'Tipo imposto',
        sortField: 'param_tipo_imposto.descr'
      },
      {
        name: 'tp_regra.descr',
        title: 'Tipo Regra',
        sortField: 'tp_regra.descr'
      },
      {
        name: '__slot:cst',
        title: 'CST',
        sortField: 'cst'
      },
      {
        name: '__slot:simplesnacional',
        title: 'Simples Nacional',
        sortField: 'simplesnacional'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },

      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
mounted() {
    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
    this.$events.$on('filter-reset', e => this.onFilterReset());
  },
methods: {
    onDetail (data, field, event) {
        this.$refs.vuetable.toggleDetailRow(data.regfis_id);
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onFilterSet (data_filter) {
        this.loadingData = true;
        this.moreParams = {
            'cd': data_filter.cd,
            'descr': data_filter.descr,
            'status': data_filter.status.value,
            'param_cst': data_filter.param_cst.value,
            'tp_regra': data_filter.tp_regra.value,
            'tp_imposto': data_filter.tp_imposto.value,
            'tp_doc': data_filter.tp_doc.value,
            'cliente': data_filter.cliente.value

        }
        Vue.nextTick( () => {this.$refs.vuetable.reload(); })
    },
    onFilterReset () {
        this.loadingData = true;
        this.moreParams = {}
        Vue.nextTick( () => this.$refs.vuetable.refresh())
    },
    onReloadData() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.reload());
    },
    onLoaded: function () {
        this.dataExport = this.$refs.vuetable.tableData;
        this.loadingData = false;
        this.$store.commit('setVuetableFilterButton', false);
    },
    onCreate ()
    {
      this.$refs.regrafiscalform.onCreate();
    },
    onCreateUnidade (data)
    {
      this.$refs.regrafiscalunidadeform.onCreate(data);
    },
    onCreateCliente (data)
    {
      this.$refs.regrafiscalclienteform.onCreate(data);
    },
    onCreateTransportador (data)
    {
      this.$refs.regrafiscaltransportadorform.onCreate(data);
    },
    onEdit (data)
    {
      this.id = data.regfis_id;
      this.$refs.regrafiscalform.onEdit(data);
    },
    onActivateDesactivate(action, data, tipo)
    {
        // Tipo = true = Checkbox
        this.helpForm.status = action;
        if(tipo)
        {

            this.helpForm.statusRecord = [];
            this.helpForm.statusRecord.push({ id: data.regfis_id, status: action });
        }
        else
        {
            this.helpForm.statusRecord = [];
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.helpForm.statusRecord.push({ id: obj, status: action })
            });
        }
        this.$refs.regrafiscalform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    },
    isFullscreen: {
        get() {
            return this.$store.getters.is_full_screen;
        }
    }
}
}
</script>
